import React, { useState } from 'react'
import StudentsIcon from '@BUP/assets/Images/Data/students_icon.svg'
import { useTranslation } from 'react-i18next'
import styles from './work-group.module.scss'
import AlertComponent from '@BUP/components/Generics/Alert'
import classNames from 'classnames'
import BupSpinner from '@BUP/components/Loading/Spinner'
import PageLayout from '@BUP/components/Layout/Page'
import SubtitleDashboard from '@BUP/components/Generics/SubtitleDashboard'
import WorkGroupComponent from '@BUP/components/SociogramDashboard/workgroupComponent'
import { useGetCurrentTerm } from '@BUP/hooks/Terms/useGetCurrentTerm'
import { useGetEventsByTermId } from '@BUP/hooks/Events/useGetEventsByTermId'
import { useGetSurveysSociogram } from '@BUP/hooks/Sociogram/useGetSurveysSociogram'

const WorkGroupPage = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })

  const { term } = useGetCurrentTerm()
  const termId = term && term.id
  const { dataEvents, isLoadingEvents } = useGetEventsByTermId(termId)
  const [showSociogramsData, setShowSociogramsData] = useState(null)

  const { dataSurveys, getSurveys, isLoadingDataSurveys } =
    useGetSurveysSociogram()

  function compare (a, b) {
    if (a.id < b.id) {
      return -1
    }
    if (a.id > b.id) {
      return 1
    }
    return 0
  }
  if (isLoadingEvents || !dataEvents) return <BupSpinner />

  dataEvents && dataEvents.sort(compare)

  const sociogramIds = dataEvents.map(obj => obj.activityId)

  const handleShowSociogramData = (sociogram, position) => {
    setShowSociogramsData(sociogram)
    getSurveys(sociogramIds[position])
  }
  // TODO remove ?
  const newGroupsDataSociogram = dataSurveys[0]?.results[0]
  const classIsSectionFirstSociogram = classNames(`${styles.workgroup_card}`, {
    [styles.active]: showSociogramsData === 'first',
    [styles.normal]: !showSociogramsData === 'second'
  })

  const classIsSectionSecondSociogram = classNames(`${styles.workgroup_card}`, {
    [styles.active]: showSociogramsData === 'second',
    [styles.normal]: showSociogramsData === 'first'
  })

  return (
    <PageLayout>
      <div>
        <SubtitleDashboard
          icon={StudentsIcon}
          text={t('toolTitle')}
        />

        <p>{t('teacher.description')}</p>
        <div style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
          <ol>
            <li>
              <p>{t('teacher.mediatorGroups')}</p>
            </li>
            <li>
              <p>{t('teacher.newLinksGroup')}</p>
            </li>
            <li>
              <p>{t('teacher.preferencesGroup')}</p>
            </li>
          </ol>
        </div>

        <div className={styles.workgroup_container}>
          <div
            className={classIsSectionFirstSociogram}
            onClick={() => handleShowSociogramData('first', 0)}
          >
            <h3>{t('teacher.sociogram1')}</h3>
          </div>
          <div
            className={classIsSectionSecondSociogram}
            onClick={() => handleShowSociogramData('second', 1)}
          >
            <h3>{t('teacher.sociogram2')}</h3>
          </div>
        </div>

        <div>
          {isLoadingDataSurveys
            ? (
              <BupSpinner />
              )
            : showSociogramsData === 'first' ||
            (showSociogramsData === 'second' && newGroupsDataSociogram)
              ? (
                <WorkGroupComponent results={newGroupsDataSociogram} />
                )
              : showSociogramsData === 'first' ||
            (showSociogramsData === 'second' && !newGroupsDataSociogram)
                ? (
                  <AlertComponent
                    message={t('teacher.errorMessage')}
                    type='warning'
                  />
                  )
                : (
                  <AlertComponent
                    message={t('teacher.alertMessage')}
                    type='info'
                  />
                  )}
        </div>
      </div>
    </PageLayout>
  )
}

export default WorkGroupPage
